import React from 'react';

import { Banner, Link, Text } from '@betterment/samba-react';

import { trackClick } from '../../../features/track';
import { Message } from '../../../graphql/schema';
import { type BannerStyle, messageBannerVariant } from '../message-box/data';

interface MinimalFeeWarningProps {
  minFeeWarning: Message;
}

export const MinimalFeeWarning: React.FC<MinimalFeeWarningProps> = ({
  minFeeWarning: { body, cta, style, trackingName },
}) => {
  const variant = messageBannerVariant[style as BannerStyle];
  return (
    <Banner variant={variant}>
      <Banner.Content>
        <Text as="p" color="text">
          <Text dangerouslySetInnerHTML={{ __html: body }} />
          {cta && cta.__typename === 'MessageCtaLink' && (
            <>
              {' '}
              <Link
                href={cta.url}
                css={{ textDecoration: 'underline', color: 'inherit', _hover: { color: 'inherit' } }}
                onClick={() => trackClick({ name: trackingName ?? 'MinimalFeeWarningLearnMore' })}
              >
                {cta.text}
              </Link>
            </>
          )}
        </Text>
      </Banner.Content>
    </Banner>
  );
};
